import { render, staticRenderFns } from "./TaskForm.vue?vue&type=template&id=0ced4c0e&scoped=true&lang=pug&"
import script from "./TaskForm.vue?vue&type=script&lang=js&"
export * from "./TaskForm.vue?vue&type=script&lang=js&"
import style0 from "./TaskForm.vue?vue&type=style&index=0&id=0ced4c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ced4c0e",
  null
  
)

export default component.exports